<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocArg'
});
</script>
<template>
  <ka-container
    code="bloc-arg"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text
      code="text"
      :options="{
        style: {
          fontSize: componentInstance.$tailleTexte.value,
          fontSizeUnit: `rem`
        }
      }"
      :value="componentInstance.$text.value" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocArgComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c19')
const component = blocArgComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  text?: Nullable<string>
  tailleTexte?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  text: '<span style="color:#D93174FF;">Visez la lune</span>, <br><span style="color:#1100A2FF;">Matchers vous prépare<br>le parcours de formation <br>pour l’atteindre.</span>',
  tailleTexte: undefined,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:text',
  'update:tailleTexte'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    text: true,
    tailleTexte: true
  }
})
</script>
